import React, { Component } from 'react';
import logo from '../../images/logomid.png';
import './InfoHome.css';

class InfoHome extends Component {
    render() {
        return (
            <div className="infoview-container">
                <nav className="navbar navbar-expand-sm navbar-color">
                    <div className="container">
                        <a className="navbar-brand" href="/">
                            <img src={logo} alt="MID" width="125" />
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="fas fa-bars" style={{ color: 'white' }}></i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item active">
                                    <a className="nav-link" href="/">
                                        Inicio
                                        <span className="sr-only">(current)</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#about">¿Quienes Somos?</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/login">Entrar</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div className="header-container">
                    <div className="container">
                        <div className="header-title">
                            <h1>
                                EL CAMBIO DE LA INDUSTRIA A TRAVÉS DE LA TECNOLOGÍA
                            </h1>
                        </div>
                    </div>
                </div>
                <div id="about" className="about-container">
                    <div className="container">
                        <div className="row mb-5 pt-4">
                            <div className="col-sm-12 col-md-6">
                                <h2>
                                    MISIÓN
                                </h2>
                                <p>
                                    MID es un sistema de recolección, análisis y manejo de datos nuevo e innovador,
                                    cuyo enfoque es mantener un vínculo máquina-hombre mediante un sistema computarizado, diseñado y
                                    dirigido por un equipo dedicado y volcado al estudio de todos los resultados que este revele de una manera clara y
                                    sin ningún tipo de manipulación. MID es capaz de adaptarse a casi cualquier industria y necesidad que está presente,
                                    dándole una ventaja competitiva sobre los demás sistemas de análisis.
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <h2>
                                    VISIÓN
                                </h2>
                                <p>
                                    Ser el sistema de recolección, análisis y manejo de datos más confiable y actualizado sin importar la industria,
                                    brindando seguridad y confianza al momento que se requiera tomar una decisión con datos e información que la respalden,
                                    mejorando la calidad del servicio que los clientes experimentaran.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <h2>
                                    VALORES
                                </h2>
                                <p>
                                    Seguridad, los clientes deben saber que la información que reciben e ingresan estará protegida ante cualquier clase de situación.
                                </p>
                                <p>
                                    Transparencia con el manejo de datos.
                                </p>
                                <p>
                                    Puntualidad en cada servicio que el
                                    sistema requiera para poder brindar el máximo desempeño
                                </p>
                                <p>
                                    Responsabilidad con el cliente y los servicios brindados.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-container">
                    <img src={logo} alt="MID" width="250" />
                </div>
            </div>
        );
    }
}
export default InfoHome;



// WEBPACK FOOTER //
// ./src/components/views/InfoHome.js